/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { shallowEqual, useSelector } from "react-redux";
import { addressToCoord } from "../../apis/maps";
import { CardBody, Card } from "../ContentLayout";
import Form from "../Form";
import { toast } from "../../utils/toast";
import useForm from "../../hooks/useForm";
import systemAlert from "../../utils/systemAlert";
import { isEmpty, get } from "lodash";
import {
  createPartner,
  getPartner,
  modifyPartner,
} from "../../apis/partner/partner";
import { viewLoading } from "../../utils/loading";
// import { isString } from "lodash";
import PartnerPreviewImage from "../../assets/images/partners/partner-preview.png";

import PartnerDetailModal from "./PartnerDetailModal";

const PartnerForm = ({ fields, fields2, buttons, ...props }) => {
  return (
    <>
      <h4 className="page-title">파트너스 설정</h4>
      <div className="partner-form-wrap">
        <div className="partner-form">
          <Form {...props} fields={fields} />
        </div>
        <div className="partner-form">
          <div className="partner-preview-image-wrap">
            <h5 className="section-title">파트너스 페이지 미리 보기</h5>
            <img
              className="partner-preview-image"
              src={PartnerPreviewImage}
              alt="파트너 상세보기 프리뷰"
            />
          </div>
          <Form {...props} fields={fields2} buttons={buttons} />
        </div>
      </div>
    </>
  );
};

const PartnerInfo = (props) => {
  const { partnerCompanyIdx, mode = "create" } = props;

  const [isReady, setIsReady] = useState(false);
  const [companyIdx, setCompanyIdx] = useState(null);

  const { company, permissions } = useSelector(
    (store) => ({
      company: store.Profile.company,
      permissions: store.Profile.permissions,
    }),
    shallowEqual
  );

  useEffect(() => {
    if (company) {
      setCompanyIdx(partnerCompanyIdx || company.managerCompanyIdx);
    }
    if (company && companyIdx && !isEmpty(permissions)) {
      setPartner();
    }
  }, [company, permissions, companyIdx]);

  const setPartner = async () => {
    viewLoading(true);
    let partner = await getPartner(companyIdx);
    if (isEmpty(partner)) {
      await createPartner({
        ...form,
        companyIdx: companyIdx,
      });
      partner = await getPartner(companyIdx);
    }
    const data = {
      ...partner,
      logoFileIdx: partner.logoFile ? [partner.logoFile] : [],
      thumbnailFileIdx: partner.thumbnailFile ? [partner.thumbnailFile] : [],
      imageFileIdx: partner.imageFile ? [partner.imageFile] : [],
      isActive: partner.isActive ? "1" : "0",
      companyIdx: companyIdx,
    };

    setOriginForm(data);
    setForm(data);
    setIsReady(true);
    viewLoading(false);
  };

  const validate = ({ name }) => {
    let errors = {};
    if (!name) errors.name = "회사이름은 필수입니다.";
    return errors;
  };

  const getParams = (params) => {
    const _params = { ...params };
    _params.logoFileIdx = get(
      _params,
      "logoFileIdx[0].fileIdx",
      get(_params, "logoFileIdx[0]")
    );

    _params.thumbnailFileIdx = get(
      _params,
      "thumbnailFileIdx[0].fileIdx",
      get(_params, "thumbnailFileIdx[0]")
    );
    _params.imageFileIdx = get(
      _params,
      "imageFileIdx[0].fileIdx",
      get(_params, "imageFileIdx[0]")
    );

    delete _params.createdTime;
    delete _params.updatedTime;
    delete _params.deletedTime;
    return _params;
  };
  const _submit = (form) => {
    systemAlert("정보를 적용하시겠습니까?", {
      buttons: [
        {
          color: "text",
          label: "취소",
        },
        {
          label: "확인",
          onClick: () => {
            modifyPartner(form.idx, getParams(form))
              .then(() => {
                systemAlert("내용이 적용 되었습니다.");
              })
              .catch((err) => {
                console.error(err.response);
              });
          },
        },
      ],
    });
  };

  const { form, setForm, setOriginForm, errors, handleOnChange, handleSubmit } =
    useForm(
      {
        isActive: "0",
        name: null,
        shortName: null,
        address: null,
        addressDetail: null,
        longitude: null,
        latitude: null,
        mobile: null,
        tel: null,
        kakaoId: null,
        email: null,
        youtube: null,
        facebook: null,
        blog: null,
        instar: null,
        logoFileIdx: null,
        // 홈페이지 추가 정보
        thumbnailFileIdx: null,
        ceoName: null,
        area: null,
        imageFileIdx: null,
        startCompany: null,
        memberInfo: null,
        mainTask: null,
        memo: null,
        homepage: null,
      },
      _submit,
      validate
    );

  const getCoord = async (form, setForm) => {
    if (form.address) {
      const address = form.address;
      const addresses = await addressToCoord({ address });
      if (addresses.length > 0) {
        form.latitude = addresses[0].y;
        form.longitude = addresses[0].x;
        setForm({ ...form });
      } else {
        toast.error("주소를 정확히 입력해주세요");
      }
    } else {
      toast.error("주소 입력 후 변환해 주세요.");
    }
  };

  const [fields, setFields] = useState([]);
  const [fields2, setFields2] = useState([]);

  // const whereToUse = (isWecake, isPartnerSite) => {
  //   let text = "";
  //   if (isWecake)
  //     text += `YDS사이트 파트너스${isString(isWecake) ? ` ${isWecake}` : ""}`;
  //   if (isPartnerSite)
  //     text += `${isWecake ? ", " : ""}홈페이지${isString(isPartnerSite) ? ` ${isPartnerSite}` : ""
  //       }`;
  //   if (isWecake || isPartnerSite) text += `에서 사용`;
  //   return text;
  // };
  useEffect(() => {
    setFields([
      [
        {
          title: "활성여부",
          key: "isActive",
          type: "radio",
          options: {
            list: [
              { label: "활성", value: "1" },
              { label: "비활성", value: "0" },
            ],
          },
          required: true,
          // after: `${whereToUse("정보 노출 여부", false)}`,
        },
      ],

      [
        {
          title: (
            <div className="partner-form-title-wrap">
              <div className="partner-form-title-before-wrap">
                <span className="round-num green">1</span>
              </div>
              <div className="partner-form-title">
                프로필 사진
                {/* <span class="color-red-100">&nbsp;*</span> */}
                <div className="partner-form-info">390x390 픽셀</div>
              </div>
            </div>
          ),
          key: "imageFileIdx",
          type: "dropzone",
          isSingle: true,
          // after: `390x390 비율, ${whereToUse("자세히보기", false)}`,
          labelWidth: 170,
        },
      ],
      [
        {
          title: (
            <div className="partner-form-title-wrap">
              <div className="partner-form-title-before-wrap">
                <span className="round-num green">2</span>
              </div>
              <div className="partner-form-title">
                상호
                <span class="color-red-100">&nbsp;*</span>
              </div>
            </div>
          ),
          key: "name",
          placeholder: "상호 입력",
          type: "input",
          required: true,
          // after: whereToUse(true, true),
          isRequiredShow: false,
          labelWidth: 170,
        },
        // {
        //   title: "짧은 이름",
        //   key: "shortName",
        //   type: "input",
        //   after: whereToUse(false, true),
        // },
      ],
      [
        {
          title: (
            <div className="partner-form-title-wrap">
              <div className="partner-form-title-before-wrap">
                <span className="round-num green">3</span>
              </div>
              <div className="partner-form-title">
                대표이름
                {/* <span class="color-red-100">&nbsp;*</span> */}
              </div>
            </div>
          ),
          placeholder: "대표이름 입력",
          key: "ceoName",
          type: "input",
          // after: whereToUse(true, false),
          labelWidth: 170,
        },
      ],
      [
        {
          title: (
            <div className="partner-form-title-wrap">
              <div className="partner-form-title-before-wrap">
                {/* <span className="round-num green">3</span> */}
              </div>
              <div className="partner-form-title">
                개업일
                {/* <span class="color-red-100">&nbsp;*</span> */}
              </div>
            </div>
          ),
          placeholder: "개업일 입력",
          key: "startCompany",
          type: "input",
          // after: whereToUse(true, false),
          labelWidth: 170,
        },
      ],

      [
        {
          title: (
            <div className="partner-form-title-wrap">
              <div className="partner-form-title-before-wrap">
                {/* <span className="round-num green">3</span> */}
              </div>
              <div className="partner-form-title">
                구성인원 정보
                {/* <span class="color-red-100">&nbsp;*</span> */}
              </div>
            </div>
          ),
          placeholder: "구성인원 정보 입력",
          key: "memberInfo",
          type: "input",
          // after: `${whereToUse("구성인원 정보", false)}`,
          labelWidth: 170,
        },
      ],
      [
        {
          title: (
            <div className="partner-form-title-wrap">
              <div className="partner-form-title-before-wrap">
                <span className="round-num green">4</span>
              </div>
              <div className="partner-form-title">
                주요업무
                {/* <span class="color-red-100">&nbsp;*</span> */}
              </div>
            </div>
          ),
          placeholder: "주요업무 입력",
          key: "mainTask",
          type: "textarea",
          // after: `엔터(줄바꿈)로 구분해주세요. ${whereToUse(
          //   "주요 업무",
          //   false
          // )}`,
          after: `엔터(줄바꿈)로 구분해주세요.`,
          labelWidth: 170,
        },
      ],
      [
        {
          title: (
            <div className="partner-form-title-wrap">
              <div className="partner-form-title-before-wrap">
                <span className="round-num green">5</span>
              </div>
              <div className="partner-form-title">
                주소
                {/* <span class="color-red-100">&nbsp;*</span> */}
              </div>
            </div>
          ),
          placeholder: "주소 입력",
          key: "address",
          type: "address",
          // after: whereToUse(true, true),
          labelWidth: 170,
        },
      ],
      [

        {
          title: (
            <div className="partner-form-title-wrap">
              <div className="partner-form-title-before-wrap">
                {/* <span className="round-num green"></span> */}
              </div>
              <div className="partner-form-title">
                경도/위도
                {/* <span class="color-red-100">&nbsp;*</span> */}
              </div>
            </div>
          ),
          key: "longitude",
          type: "input",
          placeholder: "경도 입력",
          // tooltip:
          //   "변환된 좌표는 정확하지 않을 수 있습니다. 직접수정도 가능합니다.",
          // after: whereToUse(true, true),
          labelWidth: 170,
        },
        {
          title: false,
          key: "latitude",
          placeholder: "위도 입력",
          type: "input",
          // after: whereToUse(true, true),
          className: "pr-0",
          labelWidth: 170,
        },
      ],
      [
        {
          title: <> </>,
          placeholder: "경도/위도 입력",
          type: "button",
          color: "gray-line",
          label: "주소를 좌표로 변환",
          action: () => {
            getCoord(form, setForm);
          },
          labelWidth: 170,
        },
      ],
      [
        {
          title: (
            <div className="partner-form-title-wrap">
              <div className="partner-form-title-before-wrap">
                {/* <span className="round-num green"></span> */}
              </div>
              <div className="partner-form-title">
                지역
                {/* <span class="color-red-100">&nbsp;*</span> */}
              </div>
            </div>
          ),
          key: "area",
          type: "select",
          options: {
            list: [
              { label: "없음", value: undefined },
              { label: "서울", value: "서울" },
              { label: "인천", value: "인천" },
              { label: "경기", value: "경기" },
              { label: "강원", value: "강원" },
              { label: "대전·충남북", value: "대전·충남북" },
              { label: "광주·전남북", value: "광주·전남북" },
              { label: "대구·경북", value: "대구·경북" },
              { label: "부산·울산·경남·제주", value: "부산·울산·경남·제주" },
            ],
          },
          // after: whereToUse(true, false),
          labelWidth: 170,
        },
      ],
    ]);
    setFields2([
      [
        {
          title: (
            <div className="partner-form-title-wrap">
              <div className="partner-form-title-before-wrap">
                <span className="round-num green">6</span>
              </div>
              <div className="partner-form-title">
                상담전화
                {/* <span class="color-red-100">&nbsp;*</span> */}
              </div>
            </div>
          ),
          placeholder: "상담전화 입력",
          key: "tel",
          type: "input",
          labelWidth: 170,
          // after: `${whereToUse(true, true)}, 텍스트 및 숫자 사용가능`,
        },
      ],

      [
        {
          title: (
            <div className="partner-form-title-wrap">
              <div className="partner-form-title-before-wrap">
                <span className="round-num green">7</span>
              </div>
              <div className="partner-form-title">
                홈페이지
                {/* <span class="color-red-100">&nbsp;*</span> */}
              </div>
            </div>
          ),
          placeholder: "홈페이지 입력",
          key: "homepage",
          type: "input",
          labelWidth: 170,
          after: `정책에 따라 제공되는 홈페이지로 노출될 수 있습니다.`,
        },
      ],

      [
        {
          title: (
            <div className="partner-form-title-wrap">
              <div className="partner-form-title-before-wrap">
                <span className="round-num green">8</span>
              </div>
              <div className="partner-form-title">
                회사소개
                {/* <span class="color-red-100">&nbsp;*</span> */}
              </div>
            </div>
          ),
          placeholder: "회사소개 입력",
          key: "memo",
          type: "textarea",
          labelWidth: 170,
          after: `엔터(줄바꿈)로 구분해주세요.`,
          // after: `${whereToUse("자세히보기 제일 하단", false)}`,
        },
      ],

      [
        {
          title: (
            <div className="partner-form-title-wrap">
              <div className="partner-form-title-before-wrap">
                <span className="round-num green">9</span>
              </div>
              <div className="partner-form-title">
                로고
                {/* <span class="color-red-100">&nbsp;*</span> */}
                <div className="partner-form-info">
                  300X50픽셀(가로형태)<br />
                  *PNG  파일 권장
                </div>
              </div>
            </div>
          ),
          placeholder: "로고 입력",
          key: "logoFileIdx",
          type: "dropzone",
          isSingle: true,
          labelWidth: 170,
          after: `로그인 화면에 이 로고가 노출됩니다.`,
          // after: `150x22 사이즈, ${whereToUse(true, true)}`,
        },
      ],

      [
        {
          title: (
            <div className="partner-form-title-wrap">
              <div className="partner-form-title-before-wrap">
                {/* <span className="round-num green">1</span> */}
              </div>
              <div className="partner-form-title">
                섬네일
                {/* <span class="color-red-100">&nbsp;*</span> */}
                <div className="partner-form-info">220x200 픽셀<br />목록에 노출 되는 섬네일</div>
              </div>
            </div>
          ),
          key: "thumbnailFileIdx",
          type: "dropzone",
          isSingle: true,
          labelWidth: 170,
          // after: `220x200 비율, ${whereToUse("신규 파트너 소개", false)}`,
        },
      ],
      // [
      //   {
      //     title: "모바일",
      //     key: "mobile",
      //     type: "input",
      //     after: `추후 노출 예정`,
      //     // tooltip: " '-' 및 기타 내용 직접 입력 가능합니다."
      //   },
      // ],
      // [
      //   {
      //     title: "이메일",
      //     key: "email",
      //     type: "input",
      //     after: `${whereToUse(false, true)}`,
      //   },
      //   {
      //     title: "카카오ID",
      //     key: "kakaoId",
      //     type: "input",
      //     after: `${whereToUse(false, true)}`,
      //   },
      // ],
      // [
      //   {
      //     title: "유튜브",
      //     key: "youtube",
      //     type: "input",
      //     after: `${whereToUse(false, true)}`,
      //   },
      //   {
      //     title: "페이스북",
      //     key: "facebook",
      //     type: "input",
      //     after: `${whereToUse(false, true)}`,
      //   },
      // ],
      // [
      //   {
      //     title: "블로그",
      //     key: "blog",
      //     type: "input",
      //     after: `${whereToUse(false, true)}`,
      //   },
      //   {
      //     title: "인스타",
      //     key: "instar",
      //     type: "input",
      //     after: `${whereToUse(false, true)}`,
      //   },
      // ],
    ]);
  }, [form]);
  const [isOpen, setIsOpen] = useState(false);

  const buttons = [
    {
      label: "미리보기",
      color: "line",
      className: "mr-10",
      onClick: () => {
        setIsOpen(true);
      },
    },
    {
      label: "적용하기",
      onClick: handleSubmit,
    },
  ];
  return (
    isReady && (
      <div className="partner-site-wrap">
        {partnerCompanyIdx ? (
          <PartnerForm
            mode={mode}
            form={form}
            errors={errors}
            isRequiredShow={true}
            setForm={setForm}
            fields={fields}
            fields2={fields2}
            onChange={handleOnChange}
            // submitText={"적용하기"}
            // submit={handleSubmit}
            // cancel={cancel}
            buttons={buttons}
          />
        ) : (
          <Card>
            <CardBody>
              <PartnerForm
                mode={mode}
                form={form}
                errors={errors}
                isRequiredShow={true}
                setForm={setForm}
                fields={fields}
                fields2={fields2}
                onChange={handleOnChange}
                // submitText={"적용하기"}
                // submit={handleSubmit}
                // cancel={cancel}
                buttons={buttons}
              />
            </CardBody>
          </Card>
        )}

        <PartnerDetailModal
          isOpen={isOpen}
          onClose={setIsOpen}
          partner={form}
        />
      </div>
    )
  );
};

export default PartnerInfo;
